import { MutationTree } from 'vuex';
import { State } from './state';
import { SET_LOGGED_USER } from './types';
import { IAuthUser } from '@/modules/home/models';
import { IFunctionality } from '@/modules/functionality/models';

export const mutations: MutationTree<State> = {
    [SET_LOGGED_USER](state: State, payload: IAuthUser) {
        state.authUser = payload;
    },
};
